import { Button, Input, InputNumber, Modal, Select } from "antd";

const { TextArea } = Input;
const Option = Select.Option;

export default function EditEpisode({ props }) {
  return (
    <Modal
      visible={props.isOpen}
      title="Edit Episode"
      onOk={props.submitEdit}
      onCancel={props.toggleEditPopup}
      footer={[
        <Button key="back" onClick={props.toggleEditPopup}>
          Return
        </Button>,
        <Button
          type="primary"
          key="submit"
          className={"btn btn-success"}
          loading={props.loading}
          onClick={props.submitEdit}
        >
          Submit
        </Button>,
      ]}
    >
      <div className="p-2">
        <span>Course Name</span>
        <Select
          value={props.course}
          onChange={(e) => {
            props.setNewCourse(e);
          }}
          showSearch
          size="default"
          placeholder={"Select Course"}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
          className="w-100percent ant-input mw-150"
        >
          {props.courses?.map((mode, index) => (
            <Option value={mode.id} key={index}>
              {mode.course_name}
            </Option>
          ))}
        </Select>
      </div>

      <div className="p-2">
        <span>Episode Number</span>
        <InputNumber placeholder="Input Episode Number"
                     className="w-100percent"
                     min={1}
                     max={1000}
                     value={props.episodeNumber}
                     onChange={(e) => props.setEPNumber(e)} />
      </div>

      <div className="p-2">
        <span>Episode Name</span>
        <Input
          placeholder="Edit Episode Name"
          value={props.episodeName}
          onChange={(e) => props.setEPName(e.target.value)}
        />
      </div>

      <div className="p-2">
        <span>Description</span>
        <TextArea
          placeholder="Edit Description Here"
          autosize={{ minRows: 5, maxRows: 6 }}
          value={props.description}
          onChange={(e) => props.setDesc(e.target.value)}
        />
      </div>

      <div className="p-2">
        <span>Video Url</span>
        <Input
          placeholder="Edit Video Url"
          value={props.currentVideoUrl}
          onChange={(e) => props.setVideoUrl(e.target.value)}
        />
      </div>
    </Modal>
  );
}
